import { hasLabEcom } from '../../../labs/hasLabEcom';

export const hasLabSendConversationContext = () => hasLabEcom();

export default hasLabSendConversationContext;
